// import { useMutation } from "@tanstack/react-query";
// import JSZip from "jszip";

// const useDownloadPDF = (downloadFn) => {
//   const onSuccessDownloadAndUnzipZIP = async (response) => {
//     try {
//       const zip = await JSZip.loadAsync(response.data);

//       const pdfFiles = Object.entries(zip.files)
//         .filter(([name]) => name.toLowerCase().endsWith(".pdf"))
//         .map(([name, file]) => ({ name, file }));

//       for (const { name, file } of pdfFiles) {
//         const pdfBlob = await file.async("blob");

//         const pdfFile = new File([pdfBlob], name, { type: "application/pdf" });

//         const link = document.createElement("a");
//         link.href = URL.createObjectURL(pdfFile);
//         link.download = name;
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         const pdfUrl = URL.createObjectURL(pdfFile);
//         const newTab = window.open("", "_blank");

//         if (newTab) {
//           newTab.document.write(`
//                         <!DOCTYPE html>
//                         <html>
//                         <head>
//                             <title>${name}</title>
//                             <style>
//                                 body, html { margin: 0; padding: 0; height: 100%; }
//                                 iframe { width: 100%; height: 100%; border: none; }
//                             </style>
//                         </head>
//                         <body>
//                             <iframe src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
//                                 Your browser does not support PDFs.
//                                 <a href="${pdfUrl}">Download the PDF</a>
//                             </iframe>
//                         </body>
//                         </html>
//                     `);
//           newTab.document.close();
//         } else {
//           console.warn("Pop-up blocked! Unable to open PDF directly.");
//         }

//         setTimeout(() => {
//           URL.revokeObjectURL(pdfUrl);
//         }, 5000);
//       }
//     } catch (error) {
//       console.error("Error processing ZIP file:", error);
//     }
//   };

//   const { mutate, isLoading } = useMutation(downloadFn, {
//     onSuccess: (response) => onSuccessDownloadAndUnzipZIP(response),
//     onError: (error) => {
//       console.error("Error downloading or processing the ZIP file:", error);
//     },
//   });

//   return { mutate, isLoading };
// };

// export default useDownloadPDF;

import { useMutation } from "@tanstack/react-query";
import JSZip from "jszip";

const useDownloadPDF = (downloadFn) => {
  const onSuccessDownloadAndUnzipZIP = async (response, variables) => {
    if (!response || !response.headers) {
      throw new Error("No response or headers found");
    }

    const contentType = response.headers["content-type"];
    if (contentType !== "application/zip") {
      throw new Error("Received non-ZIP content");
    }

    try {
      const zip = await JSZip.loadAsync(response.data);

      const pdfFiles = Object.entries(zip.files)
        .filter(([name]) => name.toLowerCase().endsWith(".pdf"))
        .map(([name, file]) => ({ name, file }));

      if (pdfFiles.length === 0) {
        throw new Error("No PDF files found in the ZIP archive");
      }

      for (const { name, file } of pdfFiles) {
        const pdfBlob = await file.async("blob");

        const pdfFile = new File([pdfBlob], name, { type: "application/pdf" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(pdfFile);
        link.download = name;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        const pdfUrl = URL.createObjectURL(pdfFile);
        const newTab = window.open("", "_blank");

        if (newTab) {
          newTab.document.write(`
                        <!DOCTYPE html>
                        <html>
                        <head>
                            <title>${name}</title>
                            <style>
                                body, html { margin: 0; padding: 0; height: 100%; }
                                iframe { width: 100%; height: 100%; border: none; }
                            </style>
                        </head>
                        <body>
                            <iframe src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
                                Your browser does not support PDFs. 
                                <a href="${pdfUrl}">Download the PDF</a>
                            </iframe>
                        </body>
                        </html>
                    `);
          newTab.document.close();
        } else {
          console.warn("Pop-up blocked! Unable to open PDF directly.");
        }

        setTimeout(() => {
          URL.revokeObjectURL(pdfUrl);
        }, 5000);
      }
    } catch (error) {
      console.error("Error processing ZIP file:", error);
      throw error;
    }
  };

  const { mutate, isLoading } = useMutation(downloadFn, {
    onSuccess: (response, variables) =>
      onSuccessDownloadAndUnzipZIP(response, variables),
    onError: (error) => {
      console.error("Error downloading or processing the ZIP file:", error);
      console.error("Error message:", error.message);

      if (error.originalError) {
        console.error("Original error:", error.originalError);
      }

      if (error.parsedJson) {
        console.error("Parsed JSON from error:", error.parsedJson);
      }

      if (error.blobText) {
        console.error("Error text from blob:", error.blobText);
      }

      if (error.parseError) {
        console.error("JSON parse error:", error.parseError);
      }

      if (error.blobError) {
        console.error("Blob reading error:", error.blobError);
      }

      if (error.responseStatus) {
        console.error("Response status:", error.responseStatus);
      }

      if (error.responseStatusText) {
        console.error("Response status text:", error.responseStatusText);
      }

      if (
        error.code === "NETWORK_ERROR" ||
        error.message.includes("Network Error")
      ) {
        console.error("Network connectivity issue detected");
      }

      if (error.code === "ECONNABORTED" || error.message.includes("timeout")) {
        console.error("Request timeout detected");
      }
    },
  });

  return { mutate, isLoading };
};

export default useDownloadPDF;
